import { Award } from "lucide-react";
import { Reveal } from "./Reveal";

const Membership = () => (
  <section id="membership" className="pb-24 sm:pb-32">
    <div className="max-w-2xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div
          data-testid="membership-card-iap"
          className="relative bg-[#E7DED4]/60 border border-[#B89A69]/30 rounded-3xl px-6 sm:px-10 py-9 text-center overflow-hidden"
        >
          <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#E8C2CB]/30 blur-2xl" aria-hidden="true" />
          <span className="inline-flex w-12 h-12 rounded-full bg-white border border-[#B89A69]/40 items-center justify-center mb-4 shadow-card">
            <Award size={22} strokeWidth={1.4} className="text-[#B89A69]" />
          </span>
          <p className="text-[10px] uppercase tracking-[0.24em] font-semibold text-[#8A7E88] mb-2">
            Professional Membership
          </p>
          <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#70435F] leading-snug mb-1.5">
            Indian Association of Pediatrics
          </h3>
          <p className="text-sm text-[#695E67]">Member since 2022</p>
          <span className="block w-10 h-px bg-[#B89A69] mx-auto mt-5" aria-hidden="true" />
        </div>
      </Reveal>
    </div>
  </section>
);

export default Membership;
